import React from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

const HelpOverlay = ({ store, path, helpContent, top, right, left, bottom, children, noIcon }) => {
  const helpValue = helpContent || (store && store.helpFor
    ? store.helpFor(path)
    : null
  )

  if (!helpValue) {
    return null
  }

  return (
    <OverlayTrigger
      placement={
        (top && 'top') || (right && 'right') || (bottom && 'bottom') || (left && 'left') || 'top'}
      overlay={
        <Tooltip className='tooltip-autowidth'>
          <div style={{ whiteSpace: 'pre', textAlign: 'left' }}>{helpValue}</div>
        </Tooltip>
      }>
      {children || (!noIcon
        ? <i style={{ fontSize: '14px', marginLeft: '5px' }} className='glyphicon glyphicon-question-sign' />
        : '')}
    </OverlayTrigger >
  )
}

HelpOverlay.propTypes = {
  store: PropTypes.object,
  path: PropTypes.string,
  helpContent: PropTypes.string,
  placement: PropTypes.string
}

export default HelpOverlay
